import axios, {AxiosResponse} from "axios";
import {useEffect, useState} from "react";
import "react-phone-input-2/lib/style.css";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { UPLOAD_RESTAURANT_IMAGE } from "src/constants/mutations";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/auth-provider";
import { useLocation } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import CreateRestuarantHeader from "./../../../components/CreateRestuarantHeader/CreateRestuarantHeader";
import CreateRestuarantFooter from "./../../../components/CreateRestuarantFooter/CreateRestuarantFooter";
import UploadImage from "./../../../components/UploadImage/UploadImage";
import { useSelector } from "react-redux";
import { failureToast } from "src/utils/toasts";

const STORE_LOGO_MIME_TO_EXTENSION: Record<string, string> = {
  "image/png": "png",
  "image/jpg": "jpg",
  "image/jpeg": "jpeg",
};

const storeLogoExtension = (file?: File | null) =>
  file ? STORE_LOGO_MIME_TO_EXTENSION[file.type] : undefined;

export const UploadImageRestaurant = ({ currentTabIndex, setCurrentTabIndex }: any) => {
  const { token, user } = useAuth();
  const navigate = useNavigate();
  const { state } = useLocation();
  const storeId = state?.storeId;
  const [image, setImage] = useState<string | ArrayBuffer | null>(null);
  const [imageFile, setImageFile] = useState<File | null>(null);
  const restaurant = useSelector((state: any) => state.restaurant);
  const [preSignedUrl, setPresignedUrl] = useState("");

  const formik = useFormik({
    initialValues: {
      image: "",
    },
    validationSchema: Yup.object({
      image: Yup.string().required("Image is required"),
    }),
    validateOnChange: false,
    onSubmit: () => {},
  });

  const handleFileChange = (file: File) => {
    const extension = storeLogoExtension(file);
    if (!extension) {
      failureToast("Store logo must be a PNG or JPEG image.");
      return;
    }

    formik.setFieldValue("image", file);
    setImageFile(file);
    setImage(URL.createObjectURL(file));
  };

  const uploadRestaurantImage = async () => {
    const extension = storeLogoExtension(imageFile);
    if (!imageFile || !extension) {
      failureToast("Store logo must be a PNG or JPEG image.");
      return;
    }

    const data = restaurant?.restaurantInfo?.detailInfo;
    const variables = {
      createStorePreSignedUrlInput: {
        storeUserCorrelationId: user.storeUser.correlationId,
        storeName: data.name,
        fileNameExtension: extension,
        storeCorrelationId: storeId,
      },
    };

    if (!GRAPHQL_ENDPOINT) {
      console.error("GraphQL endpoint is not defined.");
      return;
    }
    try {
      const res : AxiosResponse<any, any> = await axios.post(
        GRAPHQL_ENDPOINT,
        {
          query: UPLOAD_RESTAURANT_IMAGE,
          variables: variables,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const awsUrl = res.data.data.createUploadPreSignedUrlForStore.preSignedUrl;
      setPresignedUrl(awsUrl);

      if (res.data.errors) {
        return;
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  useEffect(() => {
    if (!preSignedUrl || !imageFile) return;

    try {
      const axiosResponse =  axios.put(preSignedUrl, imageFile, {
        headers: {
          "Content-Type": imageFile.type,
          'x-amz-acl': 'public-read'
        }
      });
      console.info(axiosResponse)
    } catch (e) {
      console.error(e)
    }
  }, [imageFile, preSignedUrl]);

  const isDisabled = !formik.isValid || !formik.dirty || !image;

  return (
    <>
      <CreateRestuarantHeader heading={'Create Restaurant'} />
      <UploadImage handleFileChange={handleFileChange} formik={formik} image={image} onSkip={() => navigate("/plans")} />
      <CreateRestuarantFooter onCancel={() => navigate("/create-restaurant", {state: {isComingBack: true}})} isDisabled={isDisabled} onContinue={uploadRestaurantImage} />
    </>
  );
};
